import Navbar from "@/components/site/Navbar";
import Banner from "@/components/site/Banner";
import Hero from "@/components/site/Hero";
import Manifesto from "@/components/site/Manifesto";
import Showcase from "@/components/site/Showcase";
import BrandMarquee from "@/components/site/BrandMarquee";
import Products from "@/components/site/Products";
import VideoSection from "@/components/site/VideoSection";
import DownloadsSection from "@/components/site/DownloadsSection";
import ContactSection from "@/components/site/ContactSection";
import Footer from "@/components/site/Footer";
import ChatWidget from "@/components/site/ChatWidget";
import Logo from "@/components/Logo";
import { useSite } from "@/context/SiteContext";

export default function Landing() {
  const { content, loading } = useSite();

  if (loading || !content) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[color:var(--aurex-bg)]">
        <div className="animate-pulse">
          <Logo size={54} showText={false} />
        </div>
      </div>
    );
  }

  return (
    <div className="relative min-h-screen bg-[color:var(--aurex-bg)] text-[color:var(--aurex-text)]">
      <Banner />
      <Navbar />
      <main>
        <Hero />
        <Manifesto />
        <Showcase />
        <BrandMarquee />
        <Products />
        <VideoSection />
        <DownloadsSection />
        <ContactSection />
      </main>
      <Footer />
      <ChatWidget />
    </div>
  );
}
